<template>
  <Modal title="検索条件設定" @close="onClose">
    <div class="customer-condition">
      <dl>
        <dt>並び順</dt>
        <dd>
          <RadioList :items="{ 0: 'お名前', 1: 'ご来店回数' }" v-model="sortType" />
        </dd>
        <dt>お客様特徴</dt>
        <dd>
          <ul class="checkbox-list">
            <li v-for="(attribute, key) in attributesMap" :key="key">
              <CheckBox :value="+key" v-model="attributes">{{ attribute.label }}</CheckBox>
            </li>
          </ul>
        </dd>
        <dt>補足情報</dt>
        <dd>
          <SelectBox
            class="select-box"
            v-model.number="supplementaryType"
            :items="{ 0: '会社名', 1: '電話番号', 2: '最終来店日' }"
          />
        </dd>
        <dt>来店回数</dt>
        <dd>
          <div class="visit-count">
            <SelectBox
              class="select--small"
              v-model.number="visitCount"
              :items="{ 0: '--', 1: '1', 3: '3', 5: '5', 10: '10', 20: '20', 30: '30', 50: '50' }"
            />
            <span class="unit">回</span>
            <SelectBox class="select--small" v-model.number="visitCondition" :items="{ 0: '以上', 1: '以下' }" />
          </div>
        </dd>
        <dt>登録日</dt>
        <dd>
          <SelectBox
            class="select-box"
            v-model.number="registerDate"
            :items="{
              0: '指定なし',
              1: '過去1ヶ月',
              2: '過去3ヶ月',
              3: '過去半年',
              4: '過去1年',
              5: '過去2年',
              6: '過去3年',
            }"
          />
        </dd>
      </dl>
    </div>
    <template #footer-center>
      <Button @click="onClear">条件を解除</Button>
      <Button primary @click="onSearch">条件で検索</Button>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/molecules/Modal'
import Button from '@/components/atoms/Button'
import CheckBox from '@/components/atoms/CheckBox'
import RadioList from '@/components/atoms/RadioList'
import SelectBox from '@/components/atoms/SelectBox'
import { attributesMap } from '@/resources/customer/attributesMap'

/**
 * 検索条件設定モーダル
 */
export default {
  name: 'ConditionModal',
  components: {
    Button,
    CheckBox,
    RadioList,
    SelectBox,
    Modal,
  },
  props: {
    condition: Object,
  },
  data() {
    return {
      sortType: this.condition.sortType,
      attributes: this.condition.attributes,
      supplementaryType: this.condition.supplementaryType,
      visitCount: this.condition.visitCount,
      visitCondition: this.condition.visitCondition,
      registerDate: this.condition.registerDate,
    }
  },
  computed: {
    attributesMap: () => attributesMap,
  },
  methods: {
    onClear() {
      this.$emit('clear')
    },
    onSearch() {
      this.$emit('change', {
        sortType: this.sortType,
        attributes: this.attributes,
        supplementaryType: this.supplementaryType,
        visitCount: this.visitCount,
        visitCondition: this.visitCondition,
        registerDate: this.registerDate,
      })
    },
    onClose() {
      this.$emit('hide')
    },
  },
}
</script>

<style lang="postcss" scoped>
.customer-condition {
  > dl {
    align-items: flex-start;
    display: grid;
    flex-wrap: wrap;
    grid-gap: 16px;
    grid-template-columns: 88px 1fr;
    text-align: left;

    dt {
      color: var(--very-dark-gray-2);
      line-height: 1.2;
      padding-top: 12px;
    }
  }

  .visit-count {
    align-items: center;
    display: grid;
    grid-gap: 8px;
    grid-template-columns: 88px 24px 88px;
  }

  .responsive & {
    @media screen and (--sp-modal) {
      dl {
        grid-template-columns: auto;
      }

      dt {
        font-size: 11px;
        font-weight: 600;
        height: auto;
      }

      .checkbox-list {
        border-top: 1px solid var(--very-light-gray-3);
        margin: 0;

        .check-box {
          border-bottom: 1px solid var(--very-light-gray-3);
          cursor: pointer;
          padding: 16px 0;
          width: 100%;

          >>> span {
            align-items: center;
            line-height: initial;
          }
        }
      }
    }
  }
}

.select-box {
  width: 168px;
}

.select--small {
  width: auto;
}
</style>
